import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { FunctionsService } from '../services/functions.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {
  block_user_management = ["/main/users/add-user", "/main/users/edit-user/", "/main/users/edit-user-picture/"]
  block_settings = ["/main/settings/custom-alerts","/main/settings/custom-alerts/add-custom-alert","/main/settings/custom-alerts/edit-custom-alert/:id","/main/settings/geo-zones/add-geozone","/main/settings/geo-zones/edit-geozone","/main/settings/notification-approvers","/main/settings/out-zone-message","/main/settings/preconfigured-messages","/main/settings/preconfigured-messages/messages-order"];
  block_account = ["/main/account","/main/account-owner"];
  block_alert_history = "/main/alertHistory/";
  block_view_alert = "/main/activeAlerts/view-alert/";
  block_alertLog = "/alertLog/";
  allow_activate = ["/main/account","/main/generalInfo","/main"];
  constructor(
    private router: Router,
    private functionsService: FunctionsService
  ) {}

  
  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  //   if (localStorage.getItem('accessToken')) {
  //     var param = route["_urlSegment"]["segments"][route["_urlSegment"]["segments"].length-1];
  //     param = param == "chat" ? route["_urlSegment"]["segments"][route["_urlSegment"]["segments"].length-2] : param;
  //     if(route["_routerState"]){
  //       if(this.block_settings.includes(route["_routerState"]["url"]) && ["SecurityAgent","Supervisor"].includes(this.functionsService.getRole())){
  //         this.router.navigateByUrl('/main/settings');
  //         return false;
  //       }
  //       if((this.block_account.includes(route["_routerState"]["url"]) && ["Admin","SecurityAgent","Supervisor"].includes(this.functionsService.getRole())) || (route["_routerState"]["url"]=="/")){
  //         this.router.navigateByUrl('/main');
  //         return false;
  //       }
  //       if((!this.allow_activate.includes(route["_routerState"]["url"])) && (this.functionsService.getRole() == "Activate")){
  //         this.router.navigateByUrl('/main/account');
  //         return false;
  //       }
  //       if((route["_routerState"]["url"].includes(this.block_alertLog) || route["_routerState"]["url"].includes(this.block_alert_history) || route["_routerState"]["url"].includes(this.block_view_alert)) && isNaN(param)){
  //         if(route["_routerState"]["url"].includes(this.block_alert_history)){
  //           this.router.navigateByUrl('/main/alertHistory');
  //         }
  //         else{
  //           this.router.navigateByUrl('/main');
  //         }
  //         return false;
  //       }
  //       if((route["_routerState"]["url"]=="/main/account") && (this.functionsService.getRole() != "Activate")){
  //         this.router.navigateByUrl('/main');
  //         return false;
  //       }
  //     }
  //     return true;
  //   } else {
  //     var r = (route["_routerState"]["url"] && route["_routerState"]["url"]!="/")?('?url='+route["_routerState"]["url"]):"";
  //     this.router.navigateByUrl('/login'+r);
  //     return false;
  //   }
  // }

  
  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (await this.functionsService.getRole()) {
      var role = await this.functionsService.getRole();
      var param = route["_urlSegment"]["segments"][route["_urlSegment"]["segments"].length-1];
      param = param == "chat" ? route["_urlSegment"]["segments"][route["_urlSegment"]["segments"].length-2] : param;
      
      if(route["_routerState"]){
        if((this.block_user_management.includes(route["_routerState"]["url"]) || route["_routerState"]["url"].includes(this.block_user_management[1]) || 
        route["_routerState"]["url"].includes(this.block_user_management[2])) && !["Admin", "Owner"].includes(role)){
          this.router.navigateByUrl('/main/users');
          return false;
        }
        if(this.block_settings.includes(route["_routerState"]["url"]) && ["SecurityAgent","Supervisor"].includes(role)){
          this.router.navigateByUrl('/main/settings');
          return false;
        }
        if((this.block_account.includes(route["_routerState"]["url"]) && ["Admin","SecurityAgent","Supervisor"].includes(role)) || (route["_routerState"]["url"]=="/")){
          this.router.navigateByUrl('/main');
          return false;
        }
        if((!this.allow_activate.includes(route["_routerState"]["url"])) && (role == "Activate")){
          this.router.navigateByUrl('/main/account');
          return false;
        }
        if((route["_routerState"]["url"].includes(this.block_alertLog) || route["_routerState"]["url"].includes(this.block_alert_history) || route["_routerState"]["url"].includes(this.block_view_alert)) && isNaN(param)){
          if(route["_routerState"]["url"].includes(this.block_alert_history)){
            this.router.navigateByUrl('/main/alertHistory');
          }
          else{
            this.router.navigateByUrl('/main');
          }
          return false;
        }
        if((route["_routerState"]["url"]=="/main/account") && (role != "Activate")){
          this.router.navigateByUrl('/main');
          return false;
        }
      }
      return true;
    } else {
      var r = (route["_routerState"]["url"] && route["_routerState"]["url"]!="/")?('?url='+route["_routerState"]["url"]):"";
      this.router.navigateByUrl('/login'+r);
      return false;
    }
  }
}
